import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickFilters = ({ activeFilters, onQuickFilter, onClearAll }) => {
  const quickFilters = [
    { id: 'verified', label: 'Verified Only', icon: 'Shield', count: 456 },
    { id: 'local', label: 'Local Organizations', icon: 'MapPin', count: 145 },
    { id: 'high-impact', label: 'High Impact', icon: 'TrendingUp', count: 234 },
    { id: 'transparent', label: 'Transparent', icon: 'Eye', count: 345 },
    { id: 'efficient', label: 'Efficient', icon: 'Target', count: 289 },
    { id: 'emergency', label: 'Emergency Relief', icon: 'AlertTriangle', count: 67 }
  ];

  const getActiveFilterCount = () => {
    let count = 0;
    Object.values(activeFilters)?.forEach(filterArray => {
      if (Array.isArray(filterArray)) {
        count += filterArray?.length;
      }
    });
    if (activeFilters?.search) count++;
    return count;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name="Zap" size={16} className="text-primary" />
          <h3 className="font-medium text-card-foreground">Quick Filters</h3>
        </div>
        {getActiveFilterCount() > 0 && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearAll}
            iconName="X"
            iconPosition="left"
            className="text-xs"
          >
            Clear All ({getActiveFilterCount()})
          </Button>
        )}
      </div>
      <div className="flex flex-wrap gap-2">
        {quickFilters?.map((filter) => {
          const isActive = activeFilters?.quickFilters?.includes(filter?.id) || false;
          
          return (
            <Button
              key={filter?.id}
              variant={isActive ? "default" : "outline"}
              size="sm"
              onClick={() => onQuickFilter(filter?.id)}
              iconName={filter?.icon}
              iconPosition="left"
              className="text-xs"
            >
              {filter?.label}
              <span className="ml-1 text-xs opacity-75">({filter?.count})</span>
            </Button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickFilters;